import BorrowerAttributeConstructor from '../borrowerAttributes/BorrowerAttributeConstructor.vue'

export default {
  data () {
    return {
      value: '',
    }
  },
  props: {
    question: Object,
  },
  components: {
    BorrowerAttributeConstructor
  },
  created() {
    // init correctly
    this.value = this.question.value || ''
  },
  computed: {
    identifier() {
      return this.question.id || this.question.alias
    },
    questionText() {
      return this.question.questionText || ''
    },
    description() {
      return this.question.description || ''
    },
    descriptionTooltip() {
      return this.question.descriptionTooltip || ''
    },
    label() {
      return this.question.name || ''
    },
    tooltipText() {
      return this.question.tooltip || this.question.helpText || ''
    },
    helpText() {
      return this.question.tooltip ? this.question.helpText : ''
    },
    disclaimer() {
      return this.question.disclaimer || ''
    },
    questionRequired() {
      return !this.question.mustAllowNull
    },
    questionUniqueId() {
      return this.question.alias && this.question.alias.replace(/[_\.]/g, '-')
    },
  },
  watch: {
    'question.value': function (val, oldVal) {
      // Dont reset to store value if stripped masked phone number matches store value
      if (this.question.type === 'tel' && this.value.replace(/\D/g, '') == val) {
        return
      }
      if (val !== oldVal && val != this.value) {
        this.value = val || ''
      }
    }
  },
  methods: {
    /**
     * Runs when revalidate is called on a page with the page-form-mixin
     */
    checkValue() {
      // Do nothing by default
    }
  },
}
